<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="title" width="400" draggable @close="handleClose">
            <div class="userAdd_man" v-if="state.isShow === true">
                <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                    <el-col :span="24" style="margin-bottom:20px;">
                        <el-form-item :label="t('scoreRedemption.user')" prop="user_id">
                            <el-select v-model="state.form.user_id" :placeholder="t('common.pleaseSelect')">
                                <el-option v-for="item in state.userOptions" :key="item.value" :label="item.label"
                                    :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom:20px;">
                        <el-form-item :label="t('scoreRedemption.redeemItem')" prop="reward_id">
                            <el-select v-model="state.form.reward_id" :placeholder="t('common.pleaseSelect')" @change="rewardChange">
                                <el-option v-for="item in state.rewardOptions" :key="item.value" :label="item.label"
                                    :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom:20px;">
                        <el-form-item v-if="state.currentReward.img" :label="t('scoreReward.itemImage')" prop="required_points">
                            <img :src="state.currentReward.img" alt="" class="reward-img">
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="state.dialogVisible = false">{{ t('common.cancel') }}</el-button>
                    <el-button type="primary" @click="submit">
                        {{ t('common.confirm') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import {
    reactive,
    ref,
    defineEmits,
    defineProps,
    defineExpose,
    onMounted,
} from "vue";
import { ElMessage } from "element-plus";
import { addApi, getUserApi, getGoodApi } from "@/api/score/rewardRecord.js";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applyScoreRedemptionFormRules } from "@/utils/scoreListI18n.js";

const emit = defineEmits([]);
defineProps({
    title: {
        type: String,
        default: "",
    },
});

const rules = reactive({
    user_id: [{ required: true, message: "", trigger: "blur" }],
    reward_id: [{ required: true, message: "", trigger: "blur" }],
});

const applyLabels = () => {
    applyScoreRedemptionFormRules(rules);
};
const { t } = usePageI18n(applyLabels);

const state = reactive({
    dialogVisible: false,
    isShow: true,
    userOptions: [],
    rewardOptions: [],
    currentReward: {
        img: ""
    },
    form: {
        "user_id": 0,
        "reward_id": 0
    }
});

const getDetailInfo = (row = {}) => {
    if (row?.id) {
        state.form = {
            ...row,
            "required_points": Number(row.required_points),
        }
    } else {
        state.form = {
            "user_id": null,
            "reward_id": null
        }
    }
}

const getAllRewardList = () => {
    getGoodApi(JSON.stringify({})).then(res => {
        if (res?.code === 200) {
            state.rewardOptions = res?.data?.map(item => {
                return {
                    label: item.reward_name,
                    value: item.id,
                    img: item.img
                }
            })
        }
    })
}

const getAllUsersList = () => {
    getUserApi(JSON.stringify({})).then(res => {
        if (res?.code === 200) {
            state.userOptions = res?.data?.map(item => {
                return {
                    label: item.real_name,
                    value: item.id
                }
            })
        }
    })
}

const open = (row) => {
    state.dialogVisible = true;
    getDetailInfo(row)
    getAllRewardList()
    getAllUsersList()
};

const rewardChange = (val) => {
    state.currentReward = state.rewardOptions.find(item => item.value == val)
}

const handleClose = () => {
    state.dialogVisible = false;
    state.form = {
        "user_id": 0,
        "reward_id": 0
    }
};

const ruleForm = ref(null)
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (valid) {
            const params = JSON.stringify(state.form)
            addApi(params).then(res => {
                if (res?.code === 200) {
                    ElMessage.success(t('common.success'))
                    state.dialogVisible = false
                    state.form = {
                        "user_id": 0,
                        "reward_id": 0
                    }
                    emit('refresh')
                } else {
                    ElMessage.error(res?.msg)
                }
            })
        } else {
            return false;
        }
    });
};

onMounted(() => {
    applyLabels();
});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}

.userFrom {
    display: flex;
    flex-wrap: wrap;
}

.el-form-item {
    margin-bottom: 0;
}

.reward-img {
    width: 200px;
    height: auto;
    border-radius: 10px;
}
</style>
